function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_794",
  "data-name": "Path 794",
  d: "M50.973,6.6,57.81,33.755h.2L64.843,6.6h9.768V43.718H67.188V32.974l.586-14.457-7.424,25.2H55.466L48.238,18.712l.586,14.261V43.718H41.4V6.6Z",
  transform: "translate(39.479 6.294)",
  fill: "#d85527"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_795",
  "data-name": "Path 795",
  d: "M80.227,35.709H70.068l-2.149,8.01H60.3L71.045,6.6h7.814L89.6,43.718H81.985Zm-8.6-5.665h7.033L75.147,16.954h-.2Z",
  transform: "translate(57.502 6.294)",
  fill: "#d85527"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_796",
  "data-name": "Path 796",
  d: "M101.8,43.718H94.764L83.628,19.884l-.2.2V43.718H76.4V6.6h7.033L94.568,30.239h.2V6.6H101.8Z",
  transform: "translate(72.855 6.294)",
  fill: "#d85527"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_797",
  "data-name": "Path 797",
  d: "M118.1,38.144a13.166,13.166,0,0,1-4.493,4.1A14.663,14.663,0,0,1,105.989,44a13.141,13.141,0,0,1-9.573-3.516Q92.9,36.972,92.9,30.525V19.584c0-4.3,1.172-7.424,3.516-9.768A12.521,12.521,0,0,1,105.6,6.3c4.1,0,7.228.977,9.182,2.93,2.149,1.954,3.126,4.884,3.126,8.6v.2h-6.838a6.828,6.828,0,0,0-1.368-4.493c-.781-.977-2.149-1.368-4.1-1.368a4.675,4.675,0,0,0-4.1,1.954,8.913,8.913,0,0,0-1.563,5.665V31.111a8.913,8.913,0,0,0,1.563,5.665,5.718,5.718,0,0,0,4.493,1.954,6.317,6.317,0,0,0,3.126-.586,5.043,5.043,0,0,0,1.758-1.758V29.353h-4.884V24.273H118.1V38.144Z",
  transform: "translate(88.59 6.008)",
  fill: "#d85527"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_798",
  "data-name": "Path 798",
  d: "M133.988,30.425c0,4.3-1.172,7.619-3.516,10.159a12.8,12.8,0,0,1-9.377,3.712c-3.907,0-7.033-1.172-9.377-3.712-2.344-2.344-3.516-5.861-3.516-10.159V20.071c0-4.3,1.172-7.619,3.516-10.159s5.47-3.712,9.377-3.712,7.033,1.172,9.377,3.712,3.516,5.861,3.516,10.159V30.425Zm-7.228-10.354a10.207,10.207,0,0,0-1.563-6.056,5.7,5.7,0,0,0-8.6,0c-.977,1.368-1.368,3.321-1.368,6.056V30.425c0,2.735.391,4.689,1.368,6.056a5.7,5.7,0,0,0,8.6,0,10.207,10.207,0,0,0,1.563-6.056V20.071Z",
  transform: "translate(103.18 5.912)",
  fill: "#d85527"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_799",
  "data-name": "Path 799",
  d: "M131.028,30.139V43.423H123.8V6.5h12.894a11.935,11.935,0,0,1,8.791,3.321c2.149,2.149,3.126,5.079,3.126,8.6a11.785,11.785,0,0,1-3.321,8.6,11.935,11.935,0,0,1-8.791,3.321h-5.47v-.2Zm0-5.861h5.665a3.944,3.944,0,0,0,3.516-1.758,7.43,7.43,0,0,0,1.172-4.3,7.429,7.429,0,0,0-1.172-4.3,3.944,3.944,0,0,0-3.516-1.758h-5.665V24.278Z",
  transform: "translate(118.056 6.198)",
  fill: "#d85527"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_800",
  "data-name": "Path 800",
  d: "M154.95,35.509h-9.768l-1.954,7.814H136L146.549,6.4h7.619l10.354,36.923h-7.228Zm-8.4-5.665h6.838l-3.321-13.089h-.2Z",
  transform: "translate(129.69 6.103)",
  fill: "#d85527"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_801",
  "data-name": "Path 801",
  d: "M163.466,22.324,169.717,6.5h7.814L166.982,30.334V43.423h-7.228V29.748L149.4,6.5h7.814Z",
  transform: "translate(142.468 6.198)",
  fill: "#d85527"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_802",
  "data-name": "Path 802",
  d: "M15.154,25.7,4.8,15.154,15.154,4.8Z",
  transform: "translate(4.577 4.577)",
  fill: "#edc05c"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_803",
  "data-name": "Path 803",
  d: "M15.154,36.208,4.8,25.854,15.154,15.5Z",
  transform: "translate(4.577 14.781)",
  fill: "#a9be68"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_804",
  "data-name": "Path 804",
  d: "M20.649,31,10.1,20.649,20.649,10.1Z",
  transform: "translate(9.631 9.631)",
  fill: "#e7804c"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_805",
  "data-name": "Path 805",
  d: "M15.5,10.1,25.854,20.649,15.5,31Z",
  transform: "translate(14.781 9.631)",
  fill: "#d43d29"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_806",
  "data-name": "Path 806",
  d: "M20.8,25.7,31.154,15.154,20.8,4.8Z",
  transform: "translate(19.835 4.577)",
  fill: "#cd302f"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_807",
  "data-name": "Path 807",
  d: "M20.8,36.208,31.154,25.854,20.8,15.5Z",
  transform: "translate(19.835 14.781)",
  fill: "#d43d29"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_808",
  "data-name": "Path 808",
  d: "M35.577,20.554a2.218,2.218,0,0,0-.586-1.563L26.2,10.2V30.908l8.791-8.6A6.209,6.209,0,0,0,35.577,20.554Z",
  transform: "translate(24.984 9.727)",
  fill: "#c22b2b"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_809",
  "data-name": "Path 809",
  d: "M.781,18.7A2.121,2.121,0,0,0,0,20.454a2.218,2.218,0,0,0,.586,1.563l8.791,8.791V10.1Z",
  transform: "translate(0 9.631)",
  fill: "#c7cd2c"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_810",
  "data-name": "Path 810",
  d: "M18.891,39.945a2.476,2.476,0,0,0,1.758.781V20.8L10.1,31.349Z",
  transform: "translate(9.631 19.835)",
  fill: "#ed9b32"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_811",
  "data-name": "Path 811",
  d: "M15.5,40.727a3.151,3.151,0,0,0,1.758-.586l8.791-8.791L15.5,20.8Z",
  transform: "translate(14.781 19.835)",
  fill: "#e26550"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_812",
  "data-name": "Path 812",
  d: "M20.649,0a3.151,3.151,0,0,0-1.758.586L10.1,9.182,20.649,19.731Z",
  transform: "translate(9.631)",
  fill: "#e7804c"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_813",
  "data-name": "Path 813",
  d: "M17.258.781A2.386,2.386,0,0,0,15.5,0V19.731L26.049,9.182Z",
  transform: "translate(14.781)",
  fill: "#ed9b32"
});

var SvgMangopay = function SvgMangopay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mangopay",
    width: 320,
    height: 60.562,
    viewBox: "0 0 320 60.562",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMangopay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mangopay.b71636fa.svg";
export { ForwardRef as ReactComponent };